import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function PopUp({
  open,
  setOpen,
  title,
  description,
  primaryText,
  secondaryText = "Cancel",
  onPrimary,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 0,
          padding: 1,
          background: "#fff",
          border: "1px solid #ddd7ce",
          boxShadow: "0 20px 70px rgba(23,23,23,0.15)",
        },
      }}
    >
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={handleClose}
            sx={{
              minWidth: 30,
              color: "#77716a",
              "&:hover": {
                background: "#f7f4ef",
              },
            }}
          >
            <CloseRoundedIcon fontSize="small" />
          </Button>
        </Box>

        <Typography
          sx={{
            mt: 1,
            fontFamily: "Georgia, serif",
            fontSize: 28,
            color: "#171717",
            textAlign: "center",
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            mt: 1.5,
            fontSize: 12,
            lineHeight: 1.8,
            color: "#77716a",
            textAlign: "center",
          }}
        >
          {description}
        </Typography>

        <Stack spacing={1.5} sx={{ mt: 3 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={onPrimary}
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              height: 48,
              borderRadius: 0,
              background: "#171717",
              color: "#fff",
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              boxShadow: "none",
              "&:hover": {
                background: "#977743",
                boxShadow: "none",
              },
            }}
          >
            {primaryText}
          </Button>

          <Button
            fullWidth
            variant="outlined"
            onClick={handleClose}
            sx={{
              height: 48,
              borderRadius: 0,
              borderColor: "#d8d2c9",
              color: "#77716a",
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              "&:hover": {
                borderColor: "#171717",
                background: "#faf8f5",
              },
            }}
          >
            {secondaryText}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}